import { t } from 'i18next';
export const formatDate = (input) => {
    const date = new Date(input);
    const today = new Date();
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
    if (date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()) {
        return t('Today');
    }
    if (date.getDate() === yesterday.getDate() &&
        date.getMonth() === yesterday.getMonth() &&
        date.getFullYear() === yesterday.getFullYear()) {
        return t('Yesterday');
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};
export const daysTo = (date) => {
    const oneDayInMillis = 1000 * 60 * 60 * 24;
    const differenceInMs = date.getTime() - Date.now();
    if (differenceInMs < 0) {
        return -1;
    }
    return Math.floor(differenceInMs / oneDayInMillis);
};
export const isExpired = (date) => {
    return date.getTime() - Date.now() < 0;
};
//# sourceMappingURL=date.js.map